import React from "react";
import { Lock, Sparkles } from "lucide-react";
import { useApp } from "../context/AppContext";

export default function RegistrationBanner() {
  const { needsRegistration, registration, requestRegistration } = useApp();
  if (!needsRegistration) return null;

  return (
    <div
      data-testid="registration-banner"
      className="fixed top-14 left-1/2 -translate-x-1/2 w-full max-w-[480px] z-30 px-3"
    >
      <div className="mt-2 rounded-2xl bg-gradient-to-r from-[#2a1b52] to-[#171525] border border-[#8b5cf6]/40 shadow-2xl p-4">
        <div className="flex items-start gap-3">
          <span className="w-9 h-9 rounded-full bg-[#8b5cf6]/20 flex items-center justify-center shrink-0">
            <Lock size={16} className="text-[#c4b1ff]" />
          </span>
          <div className="flex-1 min-w-0">
            <p className="text-[14px] font-semibold text-white">Activate your portal</p>
            <p className="text-[12px] text-white/60 mt-0.5 leading-relaxed">
              Pay the <span className="text-white font-medium">${Number(registration.fee || 11).toFixed(2)}/mo</span> registration
              to unlock editing, uploads, payouts and your shareable fan link.
            </p>
          </div>
        </div>
        <button
          data-testid="activate-portal-btn"
          onClick={requestRegistration}
          className="mt-3 w-full h-11 rounded-xl bg-[#8b5cf6] text-white text-[13px] font-semibold flex items-center justify-center gap-2 hover:bg-[#7c4ef0] transition-colors"
        >
          <Sparkles size={15} /> Activate for ${Number(registration.fee || 11).toFixed(2)}/mo
        </button>
      </div>
    </div>
  );
}
